import React from 'react';
import { Checkbox } from '@mui/material';
import { DateRow, HtmlConvertor, NameAndFolder, SimpleTooltip, SkillCard, TextRow } from 'components';
import { Images, renderGoalTypes } from 'utils';

export const targetsChooseFromLibraryTableInfo = ({ toggleItem, libraryFolders, selectedMap }) => {
    return {
        loadingType: 'GET_LIBRARY_FOLDERS',
        head: [
            {
                renderView: (
                    <SimpleTooltip title={<p>Select All</p>} placement="top-start">
                        <Checkbox
                            checked={libraryFolders?.every((folder) => selectedMap.get(folder.id)?.size === folder.targets.length)}
                            // indeterminate={libraryFolders?.some(folder =>
                            //     (selectedMap.get(folder.id)?.size || 0) > 0 &&
                            //     selectedMap.get(folder.id)?.size < folder.targets.length,
                            // )}
                            onChange={(e) =>
                                libraryFolders?.forEach((folder) => toggleItem({ folderId: folder.id, checked: e.target.checked }))
                            }
                            name={'checkBox'}
                            style={{ padding: 0, color: '#0C66E4' }}
                        />
                    </SimpleTooltip>
                ),
                width: '55px',
            },

            { name: 'name', title: 'Target Group Name', searchKey: 'name', custom: false, width: '17%' },
            { name: 'createdDate', title: 'Created Date', custom: false, disabled: true, width: '10%' },
            { name: 'creator', title: 'Creator', custom: false, disabled: true, width: '12%' },
            {
                name: 'dataTypes',
                title: 'Data Collection Method',
                disabled: true,
                custom: false,
                // multiple: true,
                // filterList: [
                //     { name: 'All', id: 'All' },
                //     ...goalDataTypes.map((goalType) => ({ id: goalType.id, name: goalType.label })),
                // ],
                width: '18%',
            },
            {
                name: 'goalType',
                title: 'Type',
                disabled: true,
                custom: false,
                // filterList: [
                //     { name: 'All', id: 'All' },
                //     ...goalTypes.map((goal) => ({ id: goal.id, name: goal.label })),
                // ],
                width: '12%',
            },
            { name: 'description', title: 'Description', custom: false, disabled: true, width: '32%' },
        ],

        body: (item) => {
            return [
                {
                    value: (
                        <div
                            onClick={(e) => {
                                e.stopPropagation();
                            }}
                            style={{
                                padding: 16,
                            }}
                        >
                            <Checkbox
                                onChange={(e) => toggleItem({ folderId: item.id, checked: e.target.checked })}
                                // indeterminate={
                                //     (selectedMap.get(item.id)?.size || 0) > 0 &&
                                //     (selectedMap.get(item.id)?.size || 0) < item.targets.length
                                // }
                                name={'checkBox'}
                                style={{ padding: 0, color: '#0C66E4' }}
                                checked={selectedMap.get(item.id)?.size === item.targets.length}
                            />
                        </div>
                    ),
                    styles: {
                        width: '55px',
                        padding: 0,
                    },
                },

                {
                    value: (
                        <NameAndFolder
                            name={item.name}
                            background={'#E7F0FC'}
                            filter={
                                'brightness(0) saturate(100%) invert(23%) sepia(60%) saturate(6129%) hue-rotate(209deg) brightness(99%) contrast(91%)'
                            }
                        />
                    ),
                    width: '17%',
                },
                { value: <DateRow date={item?.createdAt} />, width: '10%' },
                { value: <TextRow name={item?.creator} />, width: '12%' },
                { value: <TextRow name={renderGoalTypes(item?.dataType)} />, width: '18%' },
                { value: <SkillCard type={item?.goalType} />, width: '12%' },
                { value: <HtmlConvertor text={item?.description} />, width: '32%' },
            ];
        },

        notYet: {
            title: 'No Targets Yet.',
            subTitle: 'Your library is empty. Please create a targets.',
            image: Images.noClientYet,
        },
    };
};

export const optionsChooseFromLibraryTableInfo = ({ toggleItem, libraryFolders, selectedMap }) => {
    return {
        loadingType: 'GET_LIBRARY_FOLDERS',
        head: [
            {
                renderView: (
                    <SimpleTooltip title={<p>Select All</p>} placement="top-start">
                        <Checkbox
                            checked={libraryFolders?.every((folder) => selectedMap.get(folder.id)?.size === folder.options.length)}
                            // indeterminate={libraryFolders?.some(folder =>
                            //     (selectedMap.get(folder.id)?.size || 0) > 0 &&
                            //     selectedMap.get(folder.id)?.size < folder.options.length,
                            // )}
                            onChange={(e) =>
                                libraryFolders?.forEach((folder) => toggleItem({ folderId: folder.id, checked: e.target.checked }))
                            }
                            name={'checkBox'}
                            style={{ padding: 0, color: '#0C66E4' }}
                        />
                    </SimpleTooltip>
                ),
                width: '55px',
            },

            { name: 'name', title: 'Folder Name', searchKey: 'name', custom: false, width: '17%' },
            { name: 'createdDate', title: 'Created Date', custom: false, disabled: true, width: '10%' },
            { name: 'creator', title: 'Creator', custom: false, disabled: true, width: '12%' },
            {
                name: 'dataTypes',
                title: 'Data Collection Method',
                disabled: true,
                custom: false,
                // multiple: true,
                // filterList: [
                //     { name: 'All', id: 'All' },
                //     ...goalDataTypes.map((goalType) => ({ id: goalType.id, name: goalType.label })),
                // ],
                width: '18%',
            },

            { name: 'description', title: 'Description', custom: false, disabled: true, width: '39%' },
        ],

        body: (item) => {
            return [
                {
                    value: (
                        <div
                            onClick={(e) => {
                                e.stopPropagation();
                            }}
                            style={{
                                padding: 16,
                            }}
                        >
                            <Checkbox
                                onChange={(e) => toggleItem({ folderId: item.id, checked: e.target.checked })}
                                // indeterminate={
                                //     (selectedMap.get(item.id)?.size || 0) > 0 &&
                                //     (selectedMap.get(item.id)?.size || 0) < item.options.length
                                // }
                                name={'checkBox'}
                                style={{ padding: 0, color: '#0C66E4' }}
                                checked={selectedMap.get(item.id)?.size === item.options.length}
                            />
                        </div>
                    ),
                    styles: {
                        width: '55px',
                        padding: 0,
                    },
                },

                {
                    value: (
                        <NameAndFolder
                            name={item.name}
                            background={'#FCF0E6'}
                            filter={
                                'brightness(0) saturate(100%) invert(39%) sepia(67%) saturate(2231%) hue-rotate(12deg) brightness(89%) contrast(98%)'
                            }
                        />
                    ),
                    width: '17%',
                },
                { value: <DateRow date={item?.createdAt} />, width: '10%' },
                { value: <TextRow name={item?.creator} />, width: '12%' },
                { value: <TextRow name={renderGoalTypes(item?.dataType)} />, width: '18%' },
                { value: <HtmlConvertor text={item?.description} />, width: '34%' },
            ];
        },

        notYet: {
            title: 'No Options Yet.',
            subTitle: 'Your library is empty. Please create a options.',
            image: Images.noClientYet,
        },
    };
};

export const targetChooseDetailsFromLibraryNotYet = {
    title: 'No Targets Yet.',
    subTitle: 'Your library is empty. Please create a targets.',
    image: Images.noClientYet,
};

export const optionChooseDetailsFromLibraryNotYet = {
    title: 'No Options Yet.',
    subTitle: 'Your library is empty. Please create a options.',
    image: Images.noClientYet,
};
